import axios from "axios";

const MENU_URL = "/api/account/getmenu"

export function loadMenu() {
    return axios.get(MENU_URL)
        .then(response => ({ response }))
        .catch(error => ({ error }));
}